import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { alteracoesNaoSalvasGuard } from '../../core/guards/alteracoes-nao-salvas.guard';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

const BASE = 'recesso/parametrizar';
const MIGALHA_LISTA = { label: 'Parametrizar Recesso', url: `/${BASE}` };

const carregarFormulario = () =>
  import('./formulario/parametrizacao-recesso-formulario.component').then(
    (m) => m.ParametrizacaoRecessoFormularioComponent,
  );

export const parametrizacaoRecessoRoutes: Routes = [
  {
    // Tela do menu pai "Recesso" (hub com os cards das funcionalidades), como em Ajuda de Custo.
    path: 'recesso',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./hub/recesso-hub.component').then((m) => m.RecessoHubComponent),
        data: {
          title: 'Recesso',
          roles: [Role.PARAMETRO_RECESSO_CONSULTAR, Role.RECESSO_CONSULTAR],
          breadcrumb: [{ label: 'Recesso', url: '/recesso' }],
        },
      },
    ],
  },
  {
    path: BASE,
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./lista/parametrizacao-recesso-lista.component').then((m) => m.ParametrizacaoRecessoListaComponent),
        data: {
          title: 'Parametrizar Recesso do Programa',
          roles: [Role.PARAMETRO_RECESSO_CONSULTAR],
          breadcrumb: [MIGALHA_LISTA],
        },
      },
      {
        path: 'novo',
        loadComponent: carregarFormulario,
        canDeactivate: [alteracoesNaoSalvasGuard],
        data: {
          title: 'Parametrizar Recesso do Programa',
          modo: 'cadastrar',
          roles: [Role.PARAMETRO_RECESSO_EDITAR],
          breadcrumb: [MIGALHA_LISTA, { label: 'Cadastrar', url: `/${BASE}/novo` }],
        },
      },
      {
        path: ':id/editar',
        loadComponent: carregarFormulario,
        canDeactivate: [alteracoesNaoSalvasGuard],
        data: {
          title: 'Parametrizar Recesso do Programa',
          modo: 'editar',
          roles: [Role.PARAMETRO_RECESSO_EDITAR],
          breadcrumb: [MIGALHA_LISTA, { label: 'Editar', url: `/${BASE}` }],
        },
      },
      {
        path: ':id/visualizar',
        loadComponent: carregarFormulario,
        data: {
          title: 'Parametrizar Recesso do Programa',
          modo: 'visualizar',
          roles: [Role.PARAMETRO_RECESSO_CONSULTAR],
          breadcrumb: [MIGALHA_LISTA, { label: 'Visualizar', url: `/${BASE}` }],
        },
      },
    ],
  },
];
